import React, { Fragment } from 'react';
import { InspirationalDescription } from 'Components/widgets/inspirational-grid/InspirationalDescription';
import { InspirationalPicture } from 'Components/widgets/inspirational-grid/InspirationalPicture';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import {
  getContainerStyles,
  FANCY_CONTAINER_RATIO,
  HORIZONTAL_RATIO,
} from 'Components/widgets/inspirational-grid/InspirationalGrid';
import { classnames } from 'Utils/classnames/classnames.utils';
export const InspirationalGridFancy = ({
  pictures,
  title,
  subtitle,
  description,
}: InspirationalGridProps) => {
  const containerStyles = getContainerStyles(FANCY_CONTAINER_RATIO);
  const leftPanelContentStyles = 'w-[calc(530/1440*100%)]';
  const centerPanelContentStyles = 'w-[calc(480/1440*100%)]';
  const rightPanelContentStyles = 'w-[calc(430/1440*100%)]';
  const relativePadding = 'p-[calc(20/1440*100vw)]';
  const shouldDisplayInlineDescription = pictures.length < 5;
  const offsetIndex = shouldDisplayInlineDescription ? 1 : 0;
  const editorialZone = (
    <InspirationalDescription
      title={title}
      subtitle={subtitle}
      description={description}
      centered={!shouldDisplayInlineDescription}
    />
  );
  return (
    <Fragment>
      {!shouldDisplayInlineDescription && editorialZone}
      <div className="relative h-0 w-full" style={containerStyles}>
        <div className="absolute inset-0 flex overflow-hidden">
          {shouldDisplayInlineDescription ? (
            <div
              className={classnames(
                'flex h-full items-center justify-center',
                leftPanelContentStyles,
              )}
            >
              <div className="w-full max-w-3/5">{editorialZone}</div>
            </div>
          ) : (
            <div
              className={classnames('flex h-full items-end justify-end', leftPanelContentStyles)}
            >
              <div
                className={classnames(
                  'w-[calc(820/530*100%)] shrink-0 rounded-12 bg-white',
                  relativePadding,
                )}
              >
                <InspirationalPicture
                  ratioKey={HORIZONTAL_RATIO}
                  isWide
                  descriptionStyle={{
                    paddingLeft: 'calc(280 / 820 * 100%)',
                  }}
                  ratioDisplay={780 / 1440}
                  {...pictures[0 - offsetIndex]}
                  index={0 - offsetIndex + 1}
                />
              </div>
            </div>
          )}
          <div
            className={classnames(
              'relative z-1 flex h-full flex-col items-end',
              centerPanelContentStyles,
            )}
          >
            <div
              className={classnames(
                'mx-auto shrink-0 rounded-2 bg-white',
                'w-[calc(320/480*100%)]',
                relativePadding,
              )}
            >
              <InspirationalPicture
                ratioKey={HORIZONTAL_RATIO}
                isWide
                ratioDisplay={280 / 1440}
                {...pictures[1 - offsetIndex]}
                index={1 - offsetIndex + 1}
              />
            </div>
            <div
              className={classnames(
                'shrink-0 rounded-12 bg-white',
                'mr-[calc(-120/480*100%)] w-[calc(420/480*100%)]',
                relativePadding,
              )}
            >
              <InspirationalPicture
                ratioKey={HORIZONTAL_RATIO}
                isWide
                ratioDisplay={380 / 1440}
                {...pictures[2 - offsetIndex]}
                index={2 - offsetIndex + 1}
              />
            </div>
          </div>
          <div className={classnames('flex h-full flex-col', rightPanelContentStyles)}>
            <div
              className={classnames(
                'shrink-0 rounded-12 bg-white',
                'w-[calc(620/430*100%)]',
                relativePadding,
              )}
            >
              <InspirationalPicture
                ratioKey={HORIZONTAL_RATIO}
                isWide
                descriptionStyle={{
                  paddingLeft: 'calc((420% / 480 * 100) * (120 / 480) * (430 / 620) * (480 / 430))',
                  // I'm gonna need you to trust me
                  paddingRight: 'calc(180 / 620 * 100%)', // same
                }}
                ratioDisplay={580 / 1440}
                {...pictures[3 - offsetIndex]}
                index={3 - offsetIndex + 1}
              />
            </div>
            <div
              className={classnames(
                'shrink-0 rounded-12 bg-white',
                'w-[calc(320/430*100%)]',
                relativePadding,
              )}
            >
              <InspirationalPicture
                ratioKey={HORIZONTAL_RATIO}
                isWide
                ratioDisplay={280 / 1440}
                {...pictures[4 - offsetIndex]}
                index={4 - offsetIndex + 1}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
